module.exports = __webpack_public_path__ + "442a6054c4c15a7509a4bbd9bdd6e623.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/dev.jpg
// module id = nb9v
// module chunks = 0